import { Typography } from '@mui/material';
import moment from 'moment';
import {
	Datagrid,
	DateField,
	NumberField,
	ReferenceInput,
	SelectInput,
	TextField,
	useListContext,
	usePermissions,
  AutocompleteInput,} from 'react-admin';
import { BetweenDatesInput } from '../../components/BetweenDatesInput';
import ListPagination from '../../components/ListPagination';
import Permission from '../../components/Permission';
import ReportList from '../../components/ReportList';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { filterToQuery } from '../../utils';

const titleSx = {
	margin: '10px 0 10px 0',
	textAlign: 'center',
	fontWeight: 'bold'
};

const PointsList = () => {
	const props = useListContext();

	let data = [], summaryData = [];

	if (props.data) {
		const reportInfo = props.data[0];

		if (reportInfo) {
			data = reportInfo.data;
			summaryData = [reportInfo.summaryData];
		}
	}

	return (
		<>
			<Typography sx={titleSx}>Total</Typography>
			<Datagrid bulkActionButtons={false} style={{ marginBottom: 60 }} data={summaryData} total={1}>
				<NumberField
					source="total_value"
					label="Total de Pontos"
					textAlign="center"
					emptyText="0"
					options={{
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}}
					sortable={false}
				/>
			</Datagrid>

			<Typography sx={titleSx}>Pontos a Expirar</Typography>
			<Datagrid
				bulkActionButtons={false}
				resource={props.resource}
				data={data}
			>
				<TextField source="id" label="Data" />
				<NumberField
					source="points"
					label="Pontos"
					textAlign="center"
					emptyText="0"
					options={{
						maximumFractionDigits: 2
					}}
				/>
			</Datagrid>
		</>
	);
}

const FilterTablePrint = () => {
	const { filterValues } = useListContext();
	return (
		<Datagrid bulkActionButtons={false} data={[{ ...filterValues, generatedReportAt: moment().toISOString() }]} total={1}>
			<DateField source="from" textAlign="center" label="De" sortable={false} locales="pt-BR" />
			<DateField source="to" textAlign="center" label="Até" sortable={false} locales="pt-BR" />
			<DateField source="generatedReportAt" textAlign="center" label="Gerado às" showTime sortable={false} locales="pt-BR" />
		</Datagrid>
	);
}

const ReportExpirationByDate = (props) => {
	const { permissions } = usePermissions();

	const listFilters = [
		<BetweenDatesInput alwaysOn />
	];

	if (permissions && permissions.includes(PERMISSIONS.ADMIN)) {
		listFilters.push(
			<ReferenceInput
				source="chainId"
				reference="chains"
				perPage={null}
				sort={{ field: "name", order: "ASC" }}
				alwaysOn
			>
				<AutocompleteInput
					filterToQuery={filterToQuery}
					label="Rede"
					style={{ minWidth: 180 }}
					optionText={'name'}
				/>
			</ReferenceInput>)
	}

	return (
		<Permission permission={PERMISSIONS.EXPIRED_POINTS_REPORT}>
			<ReportList periodRequired
				{...props}
				basePath="fillins"
				title="Postos a Expirar"
				resource="reports/expiring-points-by-date"
				filters={listFilters}

				sort={{ field: 'created_at', order: 'DESC' }}
				filterDefaultValues={{
					chainId: getChainId(),
					from: moment().startOf('day').toISOString(),
					to: moment().endOf('day').toISOString()
				}}
				bulkActionButtons={false}
				titleOnPrint="Relatório de Pontos Expirados Por Dia"
				filterTablePrint={<FilterTablePrint />}
				landscape
				perPage={25}
				pagination={<ListPagination />}
			>
				<PointsList />
			</ReportList>
		</Permission >
	);
};

export default ReportExpirationByDate;